import * as React from "react";
import { AppPage } from "../components";
import { useTranslate } from "../helpers";

const MaintenancePage = (): JSX.Element => {
  const t = useTranslate();

  return (
    <AppPage>
      <div className="ds-u-display--flex ds-u-align-items--center m-u-flex-direction--column ">
        <section
          id="maintenance-info"
          className="ds-u-font-weight--bold ds-u-padding--2 ds-l-col--7"
        >
          <h1 className="ds-h1 ds-u-margin-bottom--0">
            {t("maintenance.header")}
          </h1>
          <p className=" ds-h2 ds-u-margin-top--2 ds-u-margin-bottom--4">
            {t("maintenance.content")}
          </p>
        </section>
      </div>
    </AppPage>
  );
};

MaintenancePage.displayName = "MaintenancePage";

export default MaintenancePage;
